<template>
    <v-app-bar class="page-top-legend" dense >

                    <!--<v-icon  class="header-icon-space page-top-legend-icon">{{titleicon}}</v-icon>-->
                    <v-toolbar-title class="page-top-legend-tile">{{titlename}}</v-toolbar-title>

                    <v-spacer></v-spacer>
                   <span style="color:white !important;"><ctrlprojectname></ctrlprojectname></span>
<!--
                    <v-btn small fab falt right="right" class="bt_margin_right" color="#049be6" @click="getdataonclick()">
                        <v-icon color="white">mdi-refresh</v-icon>
                    </v-btn>
                    <v-btn small fab falt right="right" color="#049be6" @click.stop="drawer = !drawer">
                        <v-icon color="white">mdi-filter</v-icon>
                    </v-btn>
-->
                </v-app-bar>
</template>

<script>
import ctrlprojectname from "../../../components/CtrlProjectName.vue";
export default ({
       components: {ctrlprojectname},
    name: 'WidgetStepper',
    props: {
        selectedsteps: Number,
        e1: {
            type: Number,
            default: 2,
        },
    },
    setup() {

    },
    methods: {
        
        onclickbtnDiv(varbttype) {
            // alert(varbttype);
            //alert(this.currenttab);
            if (varbttype === 1) {
                this.$router.push('/sessionalitysetting')
            }
            if (varbttype === 2) {
                this.$router.push('/adstockdecay')
            }
            if (varbttype === 3) {
                this.$router.push('/newvariablecreation')
            }
            if (varbttype === 4) {
                this.$router.push('/variabletransformation')
            }
            if (varbttype === 5) {
                this.$router.push('/variablesplit')
            }
        }
    },
    data: () => ({
        item: [],
        currenttab: this.e1,

    }),
    computed: {
        titleicon(){
            let strtitle="";
            let currtstepid=this.e1;
            if(currtstepid== 1){
                strtitle="mdi-numeric-1-circle";
            }
            if(currtstepid == 2){
                strtitle="mdi-numeric-2-circle";
            }
             if(currtstepid == 3){
                strtitle="mdi-numeric-3-circle";
            }
             if(currtstepid == 4){
                strtitle="mdi-numeric-4-circle";
            }
             if(currtstepid == 5){
                strtitle="mdi-numeric-5-circle";
            }
            return strtitle;
        },
         titlename(){
            let strtitle="";
            let currtstepid=this.e1;
            if(currtstepid== 1){
                strtitle="";
            }
            if(currtstepid == 2){
                strtitle="Adstock Decay";
            }
             if(currtstepid == 3){
                strtitle="Variable Creation";
            }
             if(currtstepid == 4){
                strtitle="Variable Transformation";
            }
             if(currtstepid == 5){
                strtitle="Variable Split";
            }
            return strtitle;
        },
        itemstest() {

            return this.$store.state.ModelDataPreparation.itemstest || [];
        },
        isCartEmpty() {
            return this.itemstest.length;
        },
        getmax() {
            if (this.itemstest.length === 0) {
                return 0;
            } else

            {
                return Math.max.apply(Math, this.itemstest);
            }

        },
        getcurrentcss() {

            return "button-selected button-slanted";
        }
    }
})
</script>

<style scoped>
.button-default {
    color: white;
    background-color: teal;
    text-align: center;
    text-transform: uppercase;
    padding: 5px 10px;
    margin: 10px;
    display: inline-block;
    cursor: pointer;
}

.button-selected {
    color: white;
    background-color: rgb(27, 184, 22);
    text-align: center;
    text-transform: uppercase;
    padding: 5px 10px;
    margin: 10px;
    display: inline-block;
    cursor: pointer;
}

.button-slanted {
    -ms-transform: skewX(-20deg);
    -webkit-transform: skewX(-20deg);
    transform: skewX(-20deg);
}

.button-slanted-content {
    -ms-transform: skewX(20deg);
    -webkit-transform: skewX(20deg);
    transform: skewX(20deg);
    display: inline-block;

    padding: 5px;
}

.button-fixedwidth {
    width: 100px;
}

.circle {
    border-radius: 50%;
    /*width: 34px;
        height: 34px;
    padding: 2px;*/
    padding-left: 5px;
    padding-right: 5px;
    background: #fff;
    border: 1px solid #000;
    color: #000;
    text-align: center;
    font: 20px Arial, sans-serif;

}

.divdisable {

    pointer-events: none;
    opacity: 0.4;
}
</style>
